import React, { useState } from 'react'
import { Modal, Input, DatePicker } from 'antd'
import styled from 'styled-components'
import { useSelector, useDispatch } from 'react-redux'
import { sendSalesOrPurchaseData } from 'src/features/WeeklySalesSlice'
import dayjs from 'dayjs'

const ForecasteddSalesModal = ({
  visibleForecastModal,
  setVisibleForecastModal,
  dateRange,
}) => {
  const [forecastedSales, setForecastedSales] = useState('')
  const [date, setDate] = useState(null)
  const venueId = useSelector(state => state.venue?.venue?._id)
  const dispatch = useDispatch()

  const resetForm = () => {
    setForecastedSales('')
    setDate(null)
  }

  const onChangeDate = selectedDate => {
    setDate(selectedDate || null)
  }

  return (
    <Modal
      width={'40%'}
      title={'Enter Forecasted Sales Data'}
      okText={'Save'}
      visible={visibleForecastModal}
      onOk={async () => {
        if (!date) return

        const body = {
          date: dayjs(date).format('YYYY-MM-DD'),
        }

        body.forecastedSales = Number(forecastedSales)
        dispatch(sendSalesOrPurchaseData(venueId, body, dateRange))
        resetForm()
        setVisibleForecastModal(false)
      }}
      onCancel={() => {
        resetForm()
        setVisibleForecastModal(false)
      }}
    >
      <SalesWrapper>
        <DatePicker
          onChange={onChangeDate}
          value={date}
          style={{ width: '60%', marginBottom: '20px' }}
        />
        <Input
          type='Number'
          style={{ width: '60%' }}
          placeholder='Forecasted Sales'
          value={forecastedSales}
          onChange={event => {
            setForecastedSales(event.target.value)
          }}
        />
      </SalesWrapper>
    </Modal>
  )
}
const SalesWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
`
export default ForecasteddSalesModal
